import React from 'react';
import { FormattedMessage } from 'react-intl';
import 'react-table-6/react-table.css';
import PasswordHeader from 'Screens/Credentials/components/Table/components/Password/PasswordHeader';
import GenericCell from 'Screens/Credentials/components/Table/components/GenericCell';
import PasswordCell from 'Screens/Credentials/components/Table/components/Password/PasswordCell';
import ActionsCell from 'Screens/Credentials/components/Table/components/ActionsCell';
import OwnedCell from 'Screens/Credentials/components/Table/components/OwnedCell';
import UsernameCell from 'Screens/Credentials/components/Table/components/UsernameCell';

export default function getColumns (hidePass, setHidePass, isFetching) {
  const columns = [
    {
      Header: () => (
        <FormattedMessage id="credentials.table.columns.endpoint" />
      ),
      id: 'endpoint',
      accessor: 'endpoint',
      show: true,
      sortable: false,
      resizable: false,
      maxWidth: 158,
      minWidth: 158,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      Cell: (rowInfo) => (
        <GenericCell
          showSkeleton={ isFetching }
          rowInfo={ rowInfo }
          field={ 'endpoint' }
        />
      )
    },
    {
      Header: () => (
        <FormattedMessage id="credentials.table.columns.username" />
      ),
      id: 'username',
      accessor: 'username',
      show: true,
      sortable: false,
      resizable: false,
      maxWidth: 168,
      minWidth: 168,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      Cell: (rowInfo) => (
        <UsernameCell
          showSkeleton={ isFetching }
          rowInfo={ rowInfo }
          field={ 'username' }
          isVulnDetail
        />
      )
    },
    {
      Header: () => (
        <PasswordHeader hidePass={ hidePass } setHidePass={ setHidePass } />
      ),
      id: 'password',
      accessor: 'password',
      show: true,
      sortable: false,
      resizable: false,
      maxWidth: 138,
      minWidth: 138,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      Cell: (rowInfo) => (
        <PasswordCell
          showSkeleton={ isFetching }
          rowInfo={ rowInfo }
          field={ 'password' }
          hidePass={ hidePass }
        />
      )
    },
    {
      Header: () => <FormattedMessage id="credentials.table.columns.owned" />,
      id: 'owned',
      accessor: 'owned',
      show: true,
      sortable: false,
      resizable: false,
      maxWidth: 70,
      minWidth: 70,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      Cell: (rowInfo) => (
        <OwnedCell showSkeleton={ isFetching } rowInfo={ rowInfo } field={ 'owned' } />
      )
    },
    {
      id: 'actions',
      accessor: 'actions',
      show: true,
      sortable: false,
      resizable: false,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      Cell: (rowInfo) => <ActionsCell showSkeleton={ isFetching } rowInfo={ rowInfo } />
    }
  ];

  const ordered_columns = columns
    .map((column) => ({
      ...column,
      // Using !column.custom_order could cause problems due to how javascript handles false values. For example, if custom_order is 0
      custom_order:
        typeof column.custom_order === 'undefined' ? 0 : column.custom_order
    }))
    .filter((row, index) => row.show === true || index === 0)
    .sort((a, b) => a.custom_order - b.custom_order);
  return ordered_columns;
}
